<div class="holiday">
  <p class="holiday__empty" *ngIf="!showTable">
    登録済みの祝日がありません。
  </p>

  <table class="holiday__table" *ngIf="showTable">
    <thead>
      <tr>
        <th>No.</th>
        <th>祝日</th>
        <th>削除</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let holiday of holidays; index as i">
        <ng-container *ngIf="getRowErrors(i) as errors">
          <td class="holiday__no">{{ i + 1 }}</td>
          <td
            class="holiday__date"
            [class.holiday__date--has-error]="errors.length > 0"
          >
            <div class="holiday__input-row">
              <input
                class="holiday__input"
                type="date"
                [(ngModel)]="holiday.date"
                [min]="minDate"
              />
            </div>
            <div class="holiday__errors" *ngIf="errors.length">
              <p class="holiday__error" *ngFor="let error of errors">
                {{ error }}
              </p>
            </div>
          </td>
          <td class="holiday__action">
            <button
              class="btn btn--white btn--outline-gray btn--small"
              type="button"
              (click)="removeHoliday(i)"
            >
              ✖️
            </button>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>

  <div class="holiday__add-row">
    <button
      class="footer__btn footer__btn--blue"
      type="button"
      (click)="addHoliday()"
    >
      祝日を追加
    </button>
  </div>
</div>

<div class="footer">
  <div class="footer__container">
    <button
      class="footer__btn footer__btn--blue"
      type="button"
      (click)="update()"
    >
      更新する
    </button>
  </div>
</div>
